import { ApiProperty } from '../codegen';
import { IsString } from '../validators';

export class FileDto {
  @ApiProperty()
  @IsString()
  name!: string;

  @ApiProperty()
  @IsString()
  url!: string;
}
